export class PaymentMethod {
  constructor(
    public id: string,
    public formaPago: string,
    public cuenta: string,
  ) {  }
}
